import React from 'react';
import PropTypes from 'prop-types';

function Store({ size, strokeWidth, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        stroke={stroke}
        strokeWidth={strokeWidth}
        d="M20.25 20.25H27V32.625H20.25V20.25Z"
        strokeLinecap="round"
      />
      <path
        stroke={stroke}
        strokeWidth={strokeWidth}
        d="M31.5 16.875V32.625H4.5V16.875"
        strokeLinecap="round"
      />
      <path
        stroke={stroke}
        strokeWidth={strokeWidth}
        d="M9 20.25H16.875V27H9V20.25Z"
        strokeLinecap="round"
      />
      <path
        stroke={stroke}
        strokeWidth={strokeWidth}
        d="M26.4375 12.6562L23.625 3.375M29.5875 3.375H6.4125L1.125 12.6562C1.125 13.7751 1.56947 14.8482 2.36064 15.6394C3.15181 16.4305 4.22487 16.875 5.34375 16.875C6.46263 16.875 7.53569 16.4305 8.32686 15.6394C9.11803 14.8482 9.5625 13.7751 9.5625 12.6562C9.5625 13.7751 10.007 14.8482 10.7981 15.6394C11.5893 16.4305 12.6624 16.875 13.7812 16.875C14.9001 16.875 15.9732 16.4305 16.7644 15.6394C17.5555 14.8482 18 13.7751 18 12.6562C18 13.7751 18.4445 14.8482 19.2356 15.6394C20.0268 16.4305 21.0999 16.875 22.2188 16.875C23.3376 16.875 24.4107 16.4305 25.2019 15.6394C25.993 14.8482 26.4375 13.7751 26.4375 12.6562C26.4375 13.7751 26.882 14.8482 27.6731 15.6394C28.4643 16.4305 29.5374 16.875 30.6562 16.875C31.7751 16.875 32.8482 16.4305 33.6394 15.6394C34.4305 14.8482 34.875 13.7751 34.875 12.6562L29.5875 3.375ZM1.125 12.375H34.875H1.125ZM18 3.375V12.6562V3.375ZM9.5625 12.6562L12.375 3.375L9.5625 12.6562Z"
        strokeLinecap="round"
      />
    </svg>
  );
}

Store.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Store;
